import { FsTimeAttackScoringPoints } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringPoints";
import { TimeAttackScoringBase } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoring";
import { TimeAttackScoringPoints } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoringPoints";
import { mapPointsDistribution } from "../../FsPointsDistribution";

export const mapTimeAttackScoringPoints = (
  base: TimeAttackScoringBase,
  fsModel: FsTimeAttackScoringPoints
): TimeAttackScoringPoints | undefined => {
  if (!fsModel.points) {
    return undefined;
  }

  const points = mapPointsDistribution(fsModel.points);
  if (!points) {
    return undefined;
  }

  return {
    ...base,
    points,
    type: "Points",
  };
};
